export type Theme = {
  brandColor: string;
  textColor: string;
  bgColor: string;
  bubbleVisitorBg: string;
  bubbleVisitorText: string;
  bubbleAiBg: string;
  bubbleAiText: string;
};

export function createTheme(brandColor: string): Theme {
  return {
    brandColor,
    textColor: '#1a1a1a',
    bgColor: '#ffffff',
    bubbleVisitorBg: brandColor,
    bubbleVisitorText: '#ffffff',
    bubbleAiBg: '#f1f3f5',
    bubbleAiText: '#1a1a1a',
  };
}
